import * as React from "react";
import { Navigate } from "react-router-dom";

import { Restricted, useAuth } from "lib/auth";

import { PERMISSIONS } from "../../../lib/biot/roles/types";

export const LandingPage: React.FC = () => {
  const [, { currentUser, loading }] = useAuth();

  // Wait for auth to finish loading before redirecting
  if (loading) {
    return null; // or a loading spinner if desired
  }

  // If user is not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Restricted permits={[PERMISSIONS.USER_VIEW]}>
        <Navigate to="/users" />
      </Restricted>
      <Restricted permits={[PERMISSIONS.PATIENT_VIEW]}>
        <Navigate to="/patients" />
      </Restricted>
    </>
  );
};
